import { subscribe, useSnapshot } from "valtio"
import { useEffect, useState } from "react"
import { AgmodalStore, bookingsStore, configStore, loginStore } from "../state/CommonState";
import TaskDatetime from "./task-datetime";
import Taskfileapproval, { validateFileApproval } from "./task-file-approval";
import Taskfiledisplay from "./task-file-display";
import Taskfiletable from "./task-file-table";
import { taskStore } from "./task-store";
import Taskapi from "./tasks-api";
import MonApi, { GET_BOOKINGS_LIST_URI } from '../state/mongo-api';
async function callback(e) {
    taskStore.current.stage = 3
    taskStore.current.status ='COMPLETED'
    taskStore.current.pendingWith = process.env.REACT_APP_ENTERPRISE_NAME_SENTENCECASE.toUpperCase()
    taskStore.setCustomerComplete()
    taskStore.setComplete()
    await Taskapi.updateTask(taskStore.current)
    taskStore.triggerActionVisible = false
    taskStore.myActionVisible = false
    if(AgmodalStore.modalPage === "TaskContainer" || loginStore.isClient()){
        AgmodalStore.pageVisible = false
        AgmodalStore.apiCall = true
    }
}
export default function Blrelease(props) {
    useSnapshot(taskStore)
    useSnapshot(configStore)
    useSnapshot(AgmodalStore)
    let task = taskStore.current
    let stage = task.stage

    const [depAction, setDepAciton] = useState({})

    if(depAction){
        task.blType = depAction.blType
    }

    useEffect(() => {
            let f = async () => {
                let ret = await Taskapi.getTaskForAction(bookingsStore.current._id,'BL Type Required')
                console.log('INSIDE INSIDE', ret)
                if (ret) {
                    setDepAciton(ret[0])
                }
            }
            f()
        }, [taskStore.current])

    if (stage === 1) {
        return (
            <div className="box">
                <tr>
                    <td style={{ width: '20rem' }}>Type of BL:</td>
                    <td>
                        <strong>{task.blType}</strong>
                    </td>                    {/* <td>
                        <select value={task.blType} onChange={(e) => {
                            task.blType = e.target.value
                        }}>
                            <option value='Seaway'>Seaway</option>
                            <option value='Original'>Original</option>
                        </select>
                    </td> */}
                </tr>
                <Taskfiledisplay />
                <p>
                    <span>
                        <button style={{ float: 'left' }} className="button islink"
                            onClick={callback}>Submit</button>
                    </span>
                </p>
            </div>
        )
    }
    if (stage >= 2) {
        return (
            <>
                <tr>
                    <td style={{ width: '20rem' }}>Type of BL:</td>
                    <td>
                        <strong>{task.blType}</strong>
                    </td>
                </tr>
                <br/>
                <Taskfiledisplay />
                <p>
                    <span>
                        {
                            (stage === 2) ?
                                <button style={{ float: 'right' }} className="button islink"
                                    onClick={async (e) => {
                                        //let task = taskStore.current
                                        task.stage = 3
                                        taskStore.setComplete()
                                        await Taskapi.updateTask(taskStore.current)
                                        taskStore.triggerActionVisible = false
                                        taskStore.myActionVisible = false
                                        if(AgmodalStore.modalPage === "TaskContainer" || loginStore.isClient()){
                                            AgmodalStore.pageVisible = false
                                            AgmodalStore.apiCall = true
                                        }
                                    }}>Acknowledge</button>
                                : <></>
                        }
                    </span>
                </p>
            </>
        )
    }
}
export function BlreleaseTrigger(props) {
    const [depAction, setDepAciton] = useState('')
    const [actionStatus, setActionStatus] = useState('')
    const [data, setData] = useState({})
    const [bookingData,setBookingData] = useState()
    useSnapshot(taskStore)
    useSnapshot(bookingsStore)
    useSnapshot(configStore)
    const [disableButton, setDisableButton] = useState(true)
    let task = taskStore.current
    let stage = task.stage
    useEffect(() => {
        let f = async () => {
            let booking = await MonApi.apost(GET_BOOKINGS_LIST_URI, {
  _id: task.bookingNum
})
            setBookingData(booking)
            const filter = booking[0].blType == 'Undecided'? {$in: ['BL Draft Approval','BL Type Required','Invoice Acceptance']}:{$in: ['BL Draft Approval','Invoice Acceptance']}
            let ret = await Taskapi.getTaskForAction(bookingsStore.current._id, filter)
            console.log('INSIDE INSIDE', ret)
            if (ret) {
                let hasBLDraft = ret.some(action => action.actionName === 'BL Draft Approval' && action.status === 'COMPLETED');
                let hasBLType = ret.some(action => action.actionName === 'BL Type Required' && action.status === 'COMPLETED');
                let hasInvoice = ret.some(action => action.actionName === 'Invoice Acceptance' && action.files.some(file=>file.label=='Freight Invoice'));
                if(booking[0].blType == 'Undecided'){
                  setDepAciton(hasBLDraft && hasBLType && hasInvoice)
                  if(!hasBLDraft){
                  setActionStatus("BL Draft Approval action not completed for this booking")
                  }else if(!hasBLType){
                    setActionStatus("BL Type Required action not completed for this booking")
                  }else if(!hasInvoice){
                    setActionStatus("Invoice Acceptance action not found for this booking")
                  }
                }else{
                  if(!hasBLDraft)
                      setActionStatus("BL Draft Approval action not completed for this booking")
                  else if(!hasInvoice){
                      setActionStatus("Invoice Acceptance action not found for this booking")  
                  }
                  setDepAciton(hasBLDraft && hasInvoice)
                }
                setData(ret.filter((action=>action.actionName == 'BL Draft Approval')))
            }
        }
        f()
        let unsubscribe = subscribe(taskStore.current, () => {
            if (taskStore.current.dueDate.length > 0) {
                setDisableButton(false)
            }else{
                setDisableButton(true)
            }
        })
        return unsubscribe
    }, [bookingsStore.current, taskStore.current])
    if (!depAction) {
        return (
            <>
                <br />
                <h1 className="title is-4">{actionStatus}</h1>
            </>
        )
    }
    return (
        <>
            <TaskDatetime />
            <br /><br /><br />
            <p>
                <button className="button islink" disabled={disableButton}
                    onClick={async (e) => {
                        taskStore.current.stage = 1
                        taskStore.current.files = data[0].files
                        taskStore.current.blType = bookingData[0]?.blType
                        setDisableButton(true)
                        await Taskapi.saveTask(taskStore.current)
                        taskStore.triggerActionVisible = false
                        taskStore.myActionVisible = false
                    }}>Trigger Action</button>
            </p>
        </>
    )
}